import LoginRoute from "./modules/Login";
import SignupRoute from "./modules/Signup";
import ForgotPasswordRoute from "./modules/ForgotPassword";
import ConfirmTemporaryPasswordRoute from "./modules/ConfirmTemporaryPassword";


export const Login = LoginRoute
export const Signup = SignupRoute
export const ForgotPassword = ForgotPasswordRoute
export const ConfirmTemporaryPassword = ConfirmTemporaryPasswordRoute